import { toDate } from '@klareospace/pharos-lib-utils';
import type { TenantBillingConfiguration, TenantBillingConfigurationView } from '@klareospace/pharos-lib-types';

// ─── Helpers ──────────────────────────────────────────────────────────────────
// The API client does not revive dates — every Date-typed field arrives as an ISO string instead.

/** Revives every `Date`-typed field of a `TenantBillingConfiguration` (or subtype) from its API JSON shape. */
export function reviveTenantBillingConfigurationDates<T extends TenantBillingConfiguration>(config: T): T {
  return {
    ...config,
    createdAt: toDate(config.createdAt) ?? config.createdAt,
    deletedAt: toDate(config.deletedAt) ?? null,
    from: toDate(config.from) ?? config.from,
    to: toDate(config.to) ?? null,
    trial: config.trial
      ? { ...config.trial, startedAt: toDate(config.trial.startedAt) ?? config.trial.startedAt }
      : null,
    updatedAt: toDate(config.updatedAt) ?? config.updatedAt,
  };
}

/** Revives the embedded `configuration`'s dates of a `TenantBillingConfigurationView`. */
export function reviveTenantBillingConfigurationView(
  view: TenantBillingConfigurationView,
): TenantBillingConfigurationView {
  return { ...view, configuration: reviveTenantBillingConfigurationDates(view.configuration) };
}
